import { render } from "./GridContacte.vue?vue&type=template&id=7d3e73fe&scoped=true&ts=true"
import script from "./GridContacte.vue?vue&type=script&lang=ts"
export * from "./GridContacte.vue?vue&type=script&lang=ts"

import "./GridContacte.vue?vue&type=style&index=0&id=7d3e73fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3e73fe"]])

export default __exports__